import {ajax_get, ajax_post} from "./index";

// 获取专家组
export const getuserlist = (data) => ajax_post('/expertgrouplist', data);
// 添加专家组
export const addusers = (data) => ajax_post('/expertgroupedit', data);
//分配专家
export const fp = (data) => ajax_get('/expertgroupassign', data);


//省级管理员列表
export const provadminlist = (data) => ajax_post('/provadminlist', data);
//省级管理员编辑
export const provadminedit = (data) => ajax_post('/provadminedit', data);
// 密码重置
export const resetpasssword = (data) => ajax_get('/pwdchg', data);



// 获取专家用户列表
export const getexpertlist = (data) => ajax_post('/expertlist', data);
//添加评估专家账号
export const addspeciallist = (data) => ajax_post('/expertedit', data);
//删除评估专家账号
export const expertdelete = (data) => ajax_get('/expertdelete', data);
//博物馆模糊查询
export const museumnamematch = (data) => ajax_get('/museumnamematch', data);

//获取首页弹框数据 expertmuseumscoredetail
export const expertmuseumscoredetail = (data) => ajax_get('/expertmuseumscoredetail', data);



//普通用户列表
export const normaluserlist = (data) => ajax_post('/userlist', data);
//删除普通用户
export const usernormaldelete = (data) => ajax_get('/museumdel', data);
export const expertgroupdelete = (data) => ajax_get('/expertgroupdelete', data);

//增加普通用户
export const normaluseredit = (data) => ajax_post('/useredit', data);

//评分统计列表查询
export const getPftjHandler = (data) => ajax_post('/scorestat', data);

//查询评估流程管理
export const pgHandler = (data) => ajax_post('/steplist', data);
//查询评估流程管理编辑
export const pgEditHandler = (data) => ajax_post('/stepedit', data);


//加分项审核列表
export const specialaddlistHanndler = (data) => ajax_get('/specialaddlist', data);
//加分项审核详情
export const specialadddetailHanndler = (data) => ajax_get('/specialadddetail', data);

//减分项审核列表
export const warningconfirmlistHanndler = (data) => ajax_get('/warningconfirmlist', data);
//减分项审核详情
export const cutscore = (data) => ajax_post('', data);

//减分项审核列表
export const scoreadjustlistHanndler = (data) => ajax_get('/scoreadjustlist', data);
//减分项审核详情
export const adminscorequeryHanndler = (data) => ajax_get('/adminscorequery', data);

export const userlistapi = (data) => ajax_get('/userlist', data);
export const userdeleteapi = (data) => ajax_get('/userdelete', data);

export const profileedit = (data) => ajax_post('/profileedit', data);
export const changephonesapi = (data) => ajax_post('/mobilechg', data);
export const getrankingHandler = (url,data) => ajax_post(url, data);

//博物馆管理员
export const libraryManage = (data) => ajax_get('/museumadminlist', data);
export const addlibraryManage = (data) => ajax_get('/museumadminedit', data);
//登陆页查询当前状态
export const loginStatusSelect = (data) => ajax_get('/stepinfo', data);

//查询博物馆数据
export const selectLibrary = (data) => ajax_get('/museumexpertquery', data);
//header查询博物馆数据
export const selectLibraryHeader = (data) => ajax_get('/museumlist', data);

//新增博物馆
export const addLibrary = (data) => ajax_get('/museumedit', data);
//获取博物馆立标
export const museumlist = (data) => ajax_get('/museumlist', data);

//获取评分查询
export const getpfcx = (data) => ajax_get('/museumvotequery', data);
export const getpfcxdetail = (data) => ajax_get('/uservotelist', data);
